import { PspContext } from "@/config/contexts";
import { useContext, useEffect, useState } from "react";

type UseFilePreviewDialogParams = {
  file: File | null | undefined;
};

type FileType = "excel-spreadsheet" | "csv" | "zip" | "doc";

export function useFilePreviewDialog({ file }: UseFilePreviewDialogParams) {
  const { lang } = useContext(PspContext);

  const [url, setUrl] = useState<string>();
  const [fileType, setFileType] = useState<FileType>();

  useEffect(() => {
    if (!file) return;
    console.log(file.type);

    if (
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    )
      setFileType("excel-spreadsheet");
    else if (file.type === "text/csv") setFileType("csv");
    else if (file.type === "application/zip") setFileType("zip");
    else if (
      file.type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    )
      setFileType("doc");
    else setFileType(undefined);

    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);

    return function () {
      URL.revokeObjectURL(objectUrl);
    };
  }, [file]);

  return { lang, url, fileType };
}
